import React from 'react'
import MainContainer from './components/main'
import UIComponents from './components/UIComponents/UIComponents'

const App = () => <MainContainer />
// const App = () => <div>Hello</div>

export default App
